import style from './index.module.css';
/**
 * use background color to style track and text color to style progress bar
 */
export default function LinearProgressBar({
	className,
}: {
	className?: string;
}) {
	const commonClass = 'absolute bg-current h-full left-0 top-0 bottom-0';
	return (
		<div className={className}>
			<span className={`${commonClass} ${style.bar1}`} />
			<span className={`${commonClass} ${style.bar2}`} />
		</div>
	);
}
